<template>
<span
    class="text-warning cursor-pointer"
    :content="helperText"
    v-tippy
><i class="fas fa-info-circle text-warning font-size-base pulse pulse-warning d-inline-block px-2"></i></span>
</template>

<script>
import Vue from "vue";
import VueTippy from "vue-tippy";
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

if (!Vue.__vueTippyInstalled) {
  Vue.use(VueTippy);
  Vue.__vueTippyInstalled = true;
}

export default {
name: "InfoTooltip",
  props: {
    helperText: {
      default: '',
      required: true,
    }
  }
}
</script>

<style scoped>

</style>